export enum SlabType {
    FLOOR = 'FLOOR',
    CEILING = 'CEILING'
}
